<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات محتوا"
        >
          <b-form
            ref="contentform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <div class="col-12 mb-2">
                    <div class="row custom-options-checkable">
                      <div class="col-md-6 mb-md-0 mb-2">
                        <input
                          id="manual"
                          v-model="Form.Type"
                          class="custom-option-item-check"
                          type="radio"
                          name="newAddress"
                          :value="0"
                          checked
                        >
                        <label
                          for="manual"
                          class="custom-option-item px-2 py-1"
                        >
                          <span class="d-flex align-items-center mb-50">
                            <feather-icon
                              icon="HashIcon"
                              size="21"
                              class="mr-50"
                            />  <span class="custom-option-item-title h4 fw-bolder mb-0">پویا</span>
                          </span>
                          <span class="d-block">درج اتوماتیک کدهای html</span>
                        </label>
                      </div>
                      <div class="col-md-6 mb-md-0 mb-2">
                        <input
                          id="automention"
                          v-model="Form.Type"
                          class="custom-option-item-check"
                          type="radio"
                          name="newAddress"
                          :value="1"
                        >
                        <label
                          for="automention"
                          class="custom-option-item px-2 py-1"
                        >
                          <span class="d-flex align-items-center mb-50">
                            <feather-icon
                              icon="HashIcon"
                              size="21"
                              class="mr-50"
                            />
                            <span class="custom-option-item-title h4 fw-bolder mb-0">پیشرفته</span>
                          </span>
                          <span class="d-block">نیاز به دانش برنامه نویسی</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <b-col
                    class="image"
                    cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                          ref="previewEl"
                          :src="Form.Image"
                          size="90px"
                          rounded
                          button
                          @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                        :ref="'refInputEl'"
                        type="file"
                        class="d-none"
                        name="Image"
                        @input="imageRenderer($event)"
                      >
                      <b-row>
                        <b-col md="12">
                          <b-form-group
                            label="عنوان"
                            label-for="Title"
                            class="mb-0"
                          >
                            <b-form-input
                              id="Title"
                              v-model="Form.Title"
                              name="Title"
                              autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-media>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="پیوند یکتا"
                      label-for="Slug"
                    >
                      <b-form-input
                        id="Sort"
                        v-model="Form.Slug"
                        name="Slug"
                        autocomplete="off"
                        dir="ltr"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="کد انحصاری"
                      label-for="Code"
                    >
                      <b-form-input
                        id="Code"
                        v-model="Form.Code"
                        name="Code"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="وضعیت"
                      label-for="IsActive"
                    >
                      <v-select
                        v-model="Form.IsActive"
                        :options="enums('IsActive')"
                        dir="rtl"
                        label="text"
                        :reduce="x => x.value"
                        :clearable="false"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <z-quill-editor
                        v-if="Form.Type == 0"
                        v-model="Form.Description"
                      />
                      <b-form-textarea
                        v-if="Form.Type == 1"
                        id="Description"
                        v-model="Form.Description"
                        name="Description"
                        autocomplete="off"
                        rows="8"
                      />
                    </b-form-group>
                  </b-col>

                  <z-seo v-model="Form" />

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZQuillEditor from '@/tools/quilleditor.vue'
import ZSeo from '@/tools/seo.vue'

export default {
  name: 'ContentDetails',
  components: {
    ZSeo,
    ZQuillEditor,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Description: null,
        Type: 0,
        IsActive: true,
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.content.add
      if (this.$route.params.id) {
        url = this.$api.content.update
      }

      const formData = new FormData(this.$refs.contentform)

      formData.append('IsActive', this.Form.IsActive)
      formData.append('Id', this.Form.Id)
      formData.append('Type', this.Form.Type)

      if (this.Form.Description) {
        formData.append('Description', this.Form.Description)
      }

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.content.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
  },
}
</script>

<style lang="scss">

@import "~@core/scss/base/pages/app-invoice.scss";
@import '~@core/scss/base/components/variables-dark';

.form-item-section {
  background-color:$product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  // overflow: hidden;
  transition: .35s height;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }

  }
}

.custom-options-checkable .custom-option-item {
  width: 100%;
  cursor: pointer;
  border-radius: 0.42rem;
  color: #82868B;
  background-color: rgba(130,134,139,.06);
  border: 1px solid #EBE9F1;
}

.custom-option-item-check:checked+.custom-option-item {
  color: #7367F0;
  background-color: rgba(115,103,240,.12);
  border-color: #7367F0;
}

.custom-option-item-check {
  position: absolute;
  clip: rect(0,0,0,0);
}
.mr-50{
  margin-right: 0.5rem;
}

.custom-options-checkable .custom-option-item .custom-option-item-title {
  color: #82868B;
}

.custom-option-item-check:checked+.custom-option-item .custom-option-item-title {
  color: #7367F0;
}

.image .media-body {
  align-self: flex-end;
}
</style>
